module.exports = __webpack_public_path__ + "img/portrait.1b99dc79.jpg";